const entries = [
  {
    icon: "ri-global-line",
    title: "网页版官网入口",
    desc: "无需安装，浏览器直接打开即看。推荐使用 Chrome、Edge 或 Safari 访问，追番体验更流畅。",
    tag: "推荐 · 免安装",
    tone: "primary",
  },
  {
    icon: "ri-restart-line",
    title: "最新备用网址",
    desc: "当官网打不开、换网址时，可先尝试刷新或更换网络，再从下方直达通道进入新站点。",
    tag: "地址已更新",
    tone: "accent",
  },
  {
    icon: "ri-wifi-line",
    title: "稳定线路切换",
    desc: "遇到卡顿或无法打开时，可切换移动数据与 WiFi，或更换线路节点，恢复稳定访问。",
    tag: "线路备用",
    tone: "secondary",
  },
  {
    icon: "ri-shield-keyhole-line",
    title: "安全访问提醒",
    desc: "请务必从本页官方入口进入，谨防仿冒站点，保护账号与隐私安全，快乐追番不踩坑。",
    tag: "安全提示",
    tone: "primary",
  },
];

export default function Access() {
  return (
    <section id="access" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
              <i className="ri-rocket-line"></i> 访问指南
            </span>
            <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">
              动漫之家打不开？从这里快速进入
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
              无论你是想打开动漫之家网页版，还是想下载动漫之家 APP，这里汇总了当前可用的官网地址与访问方式，
              遇到换网址、打不开也能第一时间找到新入口。
            </p>
          </div>
          <a
            href="#faq"
            className="whitespace-nowrap rounded-full border border-primary-300 px-5 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100"
          >
            遇到问题？查看解答
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {entries.map((e) => {
            const toneMap: Record<string, string> = {
              primary: "bg-primary-100 text-primary-700",
              accent: "bg-accent-100 text-accent-700",
              secondary: "bg-secondary-100 text-secondary-900",
            };
            return (
              <article
                key={e.title}
                className="group rounded-xl border border-background-200 bg-background-50 p-5 transition-transform duration-300 hover:-translate-y-1"
              >
                <div className="flex items-center justify-between">
                  <span className={`flex h-11 w-11 items-center justify-center rounded-lg ${toneMap[e.tone]}`}>
                    <i className={`${e.icon} text-xl`}></i>
                  </span>
                  <span className="whitespace-nowrap rounded-full bg-secondary-50 px-2.5 py-1 text-xs text-secondary-800">
                    {e.tag}
                  </span>
                </div>
                <h3 className="mt-4 text-base font-bold text-foreground-950">{e.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{e.desc}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}